import Glide from '@glidejs/glide'

export default function fdHeroSlider(){

  const sliders = document.querySelectorAll('.glide-carousel')
  const conf = {
    type: 'carousel',
    perView: 1,
    focusAt: 0,
    autoplay:4000,
  }
  
  sliders.forEach(item => {
    new Glide(item, conf).mount()
  })

    
}